import axios from "axios";

export default async function fetchKycSetting() {
  const date = new Date()?.getTime();
  const url = `${process.env.NEXT_PUBLIC_KYC_DOCUMENT_CDN}?date=${date}`;
  let result = null;
  const res = await axios({
    method: "get",
    url: url,
  });
  console.log("fetchKycSetting", res);
  if (res.status === 200) {
    result = res.data;
    return result;
  }
  return result;
}
